import {FC, Fragment, useEffect, useState} from "react";
import {
    Box,
    CircularProgress,
    FormControlLabel,
    Switch,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography
} from "@mui/material";
import Page from "../../layout/Page";
import PageHeader from "../../layout/PageHeader";
import PageContent from "../../layout/PageContent";
import {ShippingCostCarrier, ShippingCostDirection, useShippingCostsLazyQuery} from "../../Queries";

type CountryEntry = {
    alpha2: string;
    svg: string;
    region: string;
};

const countryMap: CountryEntry[] = [
    // Europe (Single Market)
    {"alpha2": "DK", "svg": "https://tradein.create2stay.com/flags/DK.svg", "region": "Europe (Single Market)"},
    {"alpha2": "DE", "svg": "https://tradein.create2stay.com/flags/DE.svg", "region": "Europe (Single Market)"},
    {"alpha2": "AT", "svg": "https://tradein.create2stay.com/flags/AT.svg", "region": "Europe (Single Market)"},
    {"alpha2": "NL", "svg": "https://tradein.create2stay.com/flags/NL.svg", "region": "Europe (Single Market)"},
    {"alpha2": "SE", "svg": "https://tradein.create2stay.com/flags/SE.svg", "region": "Europe (Single Market)"},
    {"alpha2": "BE", "svg": "https://tradein.create2stay.com/flags/BE.svg", "region": "Europe (Single Market)"},
    {"alpha2": "IE", "svg": "https://tradein.create2stay.com/flags/IE.svg", "region": "Europe (Single Market)"},
    {"alpha2": "FR", "svg": "https://tradein.create2stay.com/flags/FR.svg", "region": "Europe (Single Market)"},
    {"alpha2": "ES", "svg": "https://tradein.create2stay.com/flags/ES.svg", "region": "Europe (Single Market)"},
    {"alpha2": "RO", "svg": "https://tradein.create2stay.com/flags/RO.svg", "region": "Europe (Single Market)"},
    {"alpha2": "SI", "svg": "https://tradein.create2stay.com/flags/SI.svg", "region": "Europe (Single Market)"},
    {"alpha2": "SK", "svg": "https://tradein.create2stay.com/flags/SK.svg", "region": "Europe (Single Market)"},
    {"alpha2": "CZ", "svg": "https://tradein.create2stay.com/flags/CZ.svg", "region": "Europe (Single Market)"},
    {"alpha2": "PL", "svg": "https://tradein.create2stay.com/flags/PL.svg", "region": "Europe (Single Market)"},
    {"alpha2": "BG", "svg": "https://tradein.create2stay.com/flags/BG.svg", "region": "Europe (Single Market)"},
    {"alpha2": "CY", "svg": "https://tradein.create2stay.com/flags/CY.svg", "region": "Europe (Single Market)"},
    {"alpha2": "EE", "svg": "https://tradein.create2stay.com/flags/EE.svg", "region": "Europe (Single Market)"},
    {"alpha2": "FI", "svg": "https://tradein.create2stay.com/flags/FI.svg", "region": "Europe (Single Market)"},
    {"alpha2": "GB", "svg": "https://tradein.create2stay.com/flags/GB.svg", "region": "Europe (Outside)"},
    {"alpha2": "GR", "svg": "https://tradein.create2stay.com/flags/GR.svg", "region": "Europe (Single Market)"},
    {"alpha2": "HR", "svg": "https://tradein.create2stay.com/flags/HR.svg", "region": "Europe (Single Market)"},
    {"alpha2": "LT", "svg": "https://tradein.create2stay.com/flags/LT.svg", "region": "Europe (Single Market)"},
    {"alpha2": "LU", "svg": "https://tradein.create2stay.com/flags/LU.svg", "region": "Europe (Single Market)"},
    {"alpha2": "LV", "svg": "https://tradein.create2stay.com/flags/LV.svg", "region": "Europe (Single Market)"},
    {"alpha2": "HU", "svg": "https://tradein.create2stay.com/flags/HU.svg", "region": "Europe (Single Market)"},
    {"alpha2": "MT", "svg": "https://tradein.create2stay.com/flags/MT.svg", "region": "Europe (Single Market)"},
    {"alpha2": "NO", "svg": "https://tradein.create2stay.com/flags/NO.svg", "region": "Europe (Outside)"},
    {"alpha2": "PT", "svg": "https://tradein.create2stay.com/flags/PT.svg", "region": "Europe (Single Market)"},
    {"alpha2": "IT", "svg": "https://tradein.create2stay.com/flags/IT.svg", "region": "Europe (Single Market)"},
    // Americas
    {"alpha2": "US", "svg": "https://tradein.create2stay.com/flags/US.svg", "region": "Americas"},
    {"alpha2": "CA", "svg": "https://tradein.create2stay.com/flags/CA.svg", "region": "Americas"},
    {"alpha2": "MX", "svg": "https://tradein.create2stay.com/flags/MX.svg", "region": "Americas"},
    {"alpha2": "AR", "svg": "https://tradein.create2stay.com/flags/AR.svg", "region": "Americas"},
    {"alpha2": "CO", "svg": "https://tradein.create2stay.com/flags/CO.svg", "region": "Americas"},
    {"alpha2": "CR", "svg": "https://tradein.create2stay.com/flags/CR.svg", "region": "Americas"},
    {"alpha2": "DO", "svg": "https://tradein.create2stay.com/flags/DO.svg", "region": "Americas"},
    {"alpha2": "EC", "svg": "https://tradein.create2stay.com/flags/EC.svg", "region": "Americas"},
    {"alpha2": "PA", "svg": "https://tradein.create2stay.com/flags/PA.svg", "region": "Americas"},
    {"alpha2": "UY", "svg": "https://tradein.create2stay.com/flags/UY.svg", "region": "Americas"},
    {"alpha2": "VE", "svg": "https://tradein.create2stay.com/flags/VE.svg", "region": "Americas"},
    // Europe (Outside)
    {"alpha2": "CH", "svg": "https://tradein.create2stay.com/flags/CH.svg", "region": "Europe (Outside)"},
    {"alpha2": "AL", "svg": "https://tradein.create2stay.com/flags/AL.svg", "region": "Europe (Outside)"},
    {"alpha2": "AM", "svg": "https://tradein.create2stay.com/flags/AM.svg", "region": "Europe (Outside)"},
    {"alpha2": "AZ", "svg": "https://tradein.create2stay.com/flags/AZ.svg", "region": "Europe (Outside)"},
    {"alpha2": "BA", "svg": "https://tradein.create2stay.com/flags/BA.svg", "region": "Europe (Outside)"},
    {"alpha2": "BY", "svg": "https://tradein.create2stay.com/flags/BY.svg", "region": "Europe (Outside)"},
    {"alpha2": "FO", "svg": "https://tradein.create2stay.com/flags/FO.svg", "region": "Europe (Outside)"},
    {"alpha2": "GE", "svg": "https://tradein.create2stay.com/flags/GE.svg", "region": "Europe (Outside)"},
    {"alpha2": "IS", "svg": "https://tradein.create2stay.com/flags/IS.svg", "region": "Europe (Outside)"},
    {"alpha2": "MC", "svg": "https://tradein.create2stay.com/flags/MC.svg", "region": "Europe (Outside)"},
    {"alpha2": "MD", "svg": "https://tradein.create2stay.com/flags/MD.svg", "region": "Europe (Outside)"},
    {"alpha2": "ME", "svg": "https://tradein.create2stay.com/flags/ME.svg", "region": "Europe (Outside)"},
    {"alpha2": "MK", "svg": "https://tradein.create2stay.com/flags/MK.svg", "region": "Europe (Outside)"},
    {"alpha2": "RS", "svg": "https://tradein.create2stay.com/flags/RS.svg", "region": "Europe (Outside)"},
    {"alpha2": "RU", "svg": "https://tradein.create2stay.com/flags/RU.svg", "region": "Europe (Outside)"},
    {"alpha2": "UA", "svg": "https://tradein.create2stay.com/flags/UA.svg", "region": "Europe (Outside)"},
    // Middle East
    {"alpha2": "AE", "svg": "https://tradein.create2stay.com/flags/AE.svg", "region": "Middle East"},
    {"alpha2": "BH", "svg": "https://tradein.create2stay.com/flags/BH.svg", "region": "Middle East"},
    {"alpha2": "IL", "svg": "https://tradein.create2stay.com/flags/IL.svg", "region": "Middle East"},
    {"alpha2": "IQ", "svg": "https://tradein.create2stay.com/flags/IQ.svg", "region": "Middle East"},
    {"alpha2": "IR", "svg": "https://tradein.create2stay.com/flags/IR.svg", "region": "Middle East"},
    {"alpha2": "JO", "svg": "https://tradein.create2stay.com/flags/JO.svg", "region": "Middle East"},
    {"alpha2": "KW", "svg": "https://tradein.create2stay.com/flags/KW.svg", "region": "Middle East"},
    {"alpha2": "LB", "svg": "https://tradein.create2stay.com/flags/LB.svg", "region": "Middle East"},
    {"alpha2": "OM", "svg": "https://tradein.create2stay.com/flags/OM.svg", "region": "Middle East"},
    {"alpha2": "QA", "svg": "https://tradein.create2stay.com/flags/QA.svg", "region": "Middle East"},
    {"alpha2": "SA", "svg": "https://tradein.create2stay.com/flags/SA.svg", "region": "Middle East"},
    {"alpha2": "YE", "svg": "https://tradein.create2stay.com/flags/YE.svg", "region": "Middle East"},
    // Africa
    {"alpha2": "ZA", "svg": "https://tradein.create2stay.com/flags/ZA.svg", "region": "Africa"},
    {"alpha2": "BJ", "svg": "https://tradein.create2stay.com/flags/BJ.svg", "region": "Africa"},
    {"alpha2": "CD", "svg": "https://tradein.create2stay.com/flags/CD.svg", "region": "Africa"},
    {"alpha2": "CG", "svg": "https://tradein.create2stay.com/flags/CG.svg", "region": "Africa"},
    {"alpha2": "CI", "svg": "https://tradein.create2stay.com/flags/CI.svg", "region": "Africa"},
    {"alpha2": "CM", "svg": "https://tradein.create2stay.com/flags/CM.svg", "region": "Africa"},
    {"alpha2": "DZ", "svg": "https://tradein.create2stay.com/flags/DZ.svg", "region": "Africa"},
    {"alpha2": "EG", "svg": "https://tradein.create2stay.com/flags/EG.svg", "region": "Africa"},
    {"alpha2": "ER", "svg": "https://tradein.create2stay.com/flags/ER.svg", "region": "Africa"},
    {"alpha2": "ET", "svg": "https://tradein.create2stay.com/flags/ET.svg", "region": "Africa"},
    {"alpha2": "GH", "svg": "https://tradein.create2stay.com/flags/GH.svg", "region": "Africa"},
    {"alpha2": "KE", "svg": "https://tradein.create2stay.com/flags/KE.svg", "region": "Africa"},
    {"alpha2": "MA", "svg": "https://tradein.create2stay.com/flags/MA.svg", "region": "Africa"},
    {"alpha2": "MG", "svg": "https://tradein.create2stay.com/flags/MG.svg", "region": "Africa"},
    {"alpha2": "MU", "svg": "https://tradein.create2stay.com/flags/MU.svg", "region": "Africa"},
    {"alpha2": "MW", "svg": "https://tradein.create2stay.com/flags/MW.svg", "region": "Africa"},
    {"alpha2": "MZ", "svg": "https://tradein.create2stay.com/flags/MZ.svg", "region": "Africa"},
    {"alpha2": "NA", "svg": "https://tradein.create2stay.com/flags/NA.svg", "region": "Africa"},
    {"alpha2": "NG", "svg": "https://tradein.create2stay.com/flags/NG.svg", "region": "Africa"},
    {"alpha2": "RW", "svg": "https://tradein.create2stay.com/flags/RW.svg", "region": "Africa"},
    {"alpha2": "SD", "svg": "https://tradein.create2stay.com/flags/SD.svg", "region": "Africa"},
    {"alpha2": "SS", "svg": "https://tradein.create2stay.com/flags/SS.svg", "region": "Africa"},
    {"alpha2": "TG", "svg": "https://tradein.create2stay.com/flags/TG.svg", "region": "Africa"},
    {"alpha2": "TN", "svg": "https://tradein.create2stay.com/flags/TN.svg", "region": "Africa"},
    {"alpha2": "TZ", "svg": "https://tradein.create2stay.com/flags/TZ.svg", "region": "Africa"},
    {"alpha2": "UG", "svg": "https://tradein.create2stay.com/flags/UG.svg", "region": "Africa"},
    {"alpha2": "ZM", "svg": "https://tradein.create2stay.com/flags/ZM.svg", "region": "Africa"},
    {"alpha2": "ZW", "svg": "https://tradein.create2stay.com/flags/ZW.svg", "region": "Africa"},
    // Asia
    {"alpha2": "JP", "svg": "https://tradein.create2stay.com/flags/JP.svg", "region": "Asia"},
    {"alpha2": "KR", "svg": "https://tradein.create2stay.com/flags/KR.svg", "region": "Asia"},
    {"alpha2": "BD", "svg": "https://tradein.create2stay.com/flags/BD.svg", "region": "Asia"},
    {"alpha2": "HK", "svg": "https://tradein.create2stay.com/flags/HK.svg", "region": "Asia"},
    {"alpha2": "KH", "svg": "https://tradein.create2stay.com/flags/KH.svg", "region": "Asia"},
    {"alpha2": "KZ", "svg": "https://tradein.create2stay.com/flags/KZ.svg", "region": "Asia"},
    {"alpha2": "LK", "svg": "https://tradein.create2stay.com/flags/LK.svg", "region": "Asia"},
    {"alpha2": "MM", "svg": "https://tradein.create2stay.com/flags/MM.svg", "region": "Asia"},
    {"alpha2": "MN", "svg": "https://tradein.create2stay.com/flags/MN.svg", "region": "Asia"},
    {"alpha2": "MY", "svg": "https://tradein.create2stay.com/flags/MY.svg", "region": "Asia"},
    {"alpha2": "NP", "svg": "https://tradein.create2stay.com/flags/NP.svg", "region": "Asia"},
    {"alpha2": "PK", "svg": "https://tradein.create2stay.com/flags/PK.svg", "region": "Asia"},
    {"alpha2": "SG", "svg": "https://tradein.create2stay.com/flags/SG.svg", "region": "Asia"},
    {"alpha2": "TH", "svg": "https://tradein.create2stay.com/flags/TH.svg", "region": "Asia"},
    {"alpha2": "TW", "svg": "https://tradein.create2stay.com/flags/TW.svg", "region": "Asia"},
    {"alpha2": "UZ", "svg": "https://tradein.create2stay.com/flags/UZ.svg", "region": "Asia"},
    {"alpha2": "VN", "svg": "https://tradein.create2stay.com/flags/VN.svg", "region": "Asia"},
    // Pacific
    {"alpha2": "AU", "svg": "https://tradein.create2stay.com/flags/AU.svg", "region": "Pacific"},
    {"alpha2": "NZ", "svg": "https://tradein.create2stay.com/flags/NZ.svg", "region": "Pacific"},
];

const getCountryName = (alpha2: string): string => {
    try {
        const displayNames = new Intl.DisplayNames([navigator.language], {type: 'region'});
        return displayNames.of(alpha2) || alpha2;
    } catch {
        return alpha2;
    }
};

const regions = ["Europe (Single Market)", "Europe (Outside)", "Americas", "Middle East", "Africa", "Asia", "Pacific"];

const outboundCarriers: { id: ShippingCostCarrier; label: string }[] = [
    {id: ShippingCostCarrier.gls, label: "GLS"},
    {id: ShippingCostCarrier.deutsche_post, label: "Deutsche Post / DHL"},
    {id: ShippingCostCarrier.dhl_express, label: "DHL Express"}
];

const inboundCarriers: { id: ShippingCostCarrier; label: string }[] = [
    {id: ShippingCostCarrier.b2c_europe, label: "Maersk"},
    {id: ShippingCostCarrier.dhl_express, label: "DHL Express"}
];

const weights = [
    {value: 1, label: "<1kg"}
];

type CostData = {
    [key: string]: number | null;
};

type DirectionTab = 'outbound' | 'inbound';

export const ShippingCostsPage: FC = () => {
    const [loading, setLoading] = useState(true);
    const [costData, setCostData] = useState<CostData>({});
    const [includeVat, setIncludeVat] = useState(false);
    const [activeTab, setActiveTab] = useState<DirectionTab>('outbound');
    const [executeQuery] = useShippingCostsLazyQuery({fetchPolicy: 'no-cache'});

    const carriers = activeTab === 'outbound' ? outboundCarriers : inboundCarriers;
    const direction = activeTab === 'outbound' ? ShippingCostDirection.outbound : ShippingCostDirection.return;
    const queryCountries = activeTab === 'outbound' ? countryMap : countryMap.filter(c => c.alpha2 !== 'DK');
    const denmark = countryMap.find(c => c.alpha2 === 'DK')!;

    useEffect(() => {
        fetchShippingCosts();
    }, [includeVat, activeTab]);

    const fetchShippingCosts = async () => {
        setLoading(true);

        const queries = queryCountries.flatMap(country =>
            carriers.flatMap(carrier =>
                weights.map(weight => ({
                    carrier: carrier.id,
                    country: country.alpha2,
                    weight: weight.value,
                    direction
                }))
            )
        );

        try {
            const {data} = await executeQuery({
                variables: {
                    queries,
                    currency: "DKK",
                    includeVat
                }
            });

            if (data?.ShippingCosts) {
                const newCostData: CostData = {};
                data.ShippingCosts.forEach(result => {
                    if (result) {
                        const key = `${result.carrier}_${result.country}_${result.weight}`;
                        newCostData[key] = result.cost ?? null;
                    }
                });
                setCostData(newCostData);
            }
        } catch (error) {
            console.error('Failed to fetch shipping costs:', error);
        } finally {
            setLoading(false);
        }
    };

    const getCost = (carrier: ShippingCostCarrier, country: string, weight: number): string => {
        const key = `${carrier}_${country}_${weight}`;
        const cost = costData[key];
        if (cost === null || cost === undefined) {
            return "-";
        }
        return `${cost.toFixed(2)} DKK`;
    };

    const pageTitle = activeTab === 'outbound' ? 'Outbound shipping costs' : 'Inbound shipping costs';

    return (
        <Page>
            <PageHeader title={pageTitle}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={includeVat}
                            onChange={(e) => setIncludeVat(e.target.checked)}
                            size="small"
                        />
                    }
                    label="Include VAT"
                />
            </PageHeader>
            <PageContent>
                <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
                    <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
                        <Tab label="Outbound" value="outbound"/>
                        <Tab label="Inbound" value="inbound"/>
                    </Tabs>
                </Box>
                {loading ? (
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4}}>
                        <CircularProgress size={24}/>
                        <Typography sx={{ml: 2}}>Loading shipping costs...</Typography>
                    </Box>
                ) : (
                    <TableContainer>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{fontWeight: 'bold', position: 'sticky', left: 0, bgcolor: 'background.paper', zIndex: 3}}>
                                        Country
                                    </TableCell>
                                    {carriers.map(carrier =>
                                        weights.map(weight => (
                                            <TableCell
                                                key={`${carrier.id}_${weight.value}`}
                                                align="right"
                                                sx={{fontWeight: 'bold', whiteSpace: 'nowrap'}}
                                            >
                                                {carrier.label}<br/>
                                                <Typography variant="caption" color="textSecondary">
                                                    {weight.label}
                                                </Typography>
                                            </TableCell>
                                        ))
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {regions.map(region => {
                                    let regionCountries = countryMap.filter(c => c.region === region);
                                    if (activeTab === 'inbound' && region === 'Europe (Single Market)') {
                                        regionCountries = [denmark, ...regionCountries.filter(c => c.alpha2 !== 'DK')];
                                    }
                                    if (regionCountries.length === 0) return null;
                                    return (
                                        <Fragment key={region}>
                                            <TableRow>
                                                <TableCell
                                                    colSpan={1 + carriers.length * weights.length}
                                                    sx={{
                                                        bgcolor: '#f5f5f5',
                                                        fontWeight: 'bold',
                                                        position: 'sticky',
                                                        left: 0
                                                    }}
                                                >
                                                    {region}
                                                </TableCell>
                                            </TableRow>
                                            {regionCountries.map(country => (
                                                <TableRow key={country.alpha2} hover>
                                                    <TableCell sx={{position: 'sticky', left: 0, bgcolor: 'background.paper', zIndex: 1}}>
                                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                            <img
                                                                src={country.svg}
                                                                alt={country.alpha2}
                                                                style={{width: 24, height: 16, objectFit: 'cover'}}
                                                            />
                                                            {getCountryName(country.alpha2)} ({country.alpha2})
                                                        </Box>
                                                    </TableCell>
                                                    {carriers.map(carrier =>
                                                        weights.map(weight => (
                                                            <TableCell
                                                                key={`${carrier.id}_${country.alpha2}_${weight.value}`}
                                                                align="right"
                                                                sx={{
                                                                    color: getCost(carrier.id, country.alpha2, weight.value) === "-" ? 'text.disabled' : 'text.primary'
                                                                }}
                                                            >
                                                                {getCost(carrier.id, country.alpha2, weight.value)}
                                                            </TableCell>
                                                        ))
                                                    )}
                                                </TableRow>
                                            ))}
                                        </Fragment>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </PageContent>
        </Page>
    );
};
